export enum EventNames {
  // Landing Page Event
  freeTrialLandingPageViewed = 'me.free_trial_landing_page_viewed',

  // Form-related Events
  freeTrialBookCtaClicked = 'me.free_trial_book_cta_clicked',
  // "See pricing" under a CTA. price_shown says whether the price was on screen (desktop) or one tap away (phones).
  seePricingClicked = 'me.see_pricing_clicked',
  freeTrialFormStarted = 'me.free_trial_form_started',
  freeTrialFormStep1Completed = 'me.free_trial_form_step_1_completed',
  freeTrialTimeSlotSelected = 'me.free_trial_time_slot_selected',
  freeTrialDateSelected = 'me.free_trial_date_selected',
  freeTrialFormCompleted = 'me.free_trial_form_completed',
  // The server rejected a submit. Carries field names only, never values.
  freeTrialFormFailed = 'me.free_trial_form_failed',
  // The browser's own validation stopped a submit. Carries field names only, never values.
  freeTrialFormBlocked = 'me.free_trial_form_blocked',
  freeTrialFormAbandoned = 'me.free_trial_form_abandoned',

  freeTrialBookingConfirmationViewed = 'me.free_trial_booking_confirmation_viewed',

  // Captured server-side, from the MCP server: there is no browser on that
  // path, so it is deliberately NOT the confirmation event above. It has none
  // of the preceding funnel steps and would distort them.
  trialBookingSubmittedViaMcp = 'me.trial_booking_submitted_via_mcp',

  // Back Button Events
  freeTrialBackButtonClickedStep1 = 'me.free_trial_back_button_clicked_step_1', // Back button on Step 1
  freeTrialBackButtonClickedStep2 = 'me.free_trial_back_button_clicked_step_2', // Back button on Step 2
  freeTrialBackButtonClickedTimeSlot = 'me.free_trial_back_button_clicked_time_slot', // Back button on Time Slot selection

  // Back Button Events
  freeTrialModalClosed = 'me.free_trial_modal_closed', // User clicks on modal overlay to close or esc

  // Form Field Input Events
  freeTrialFieldInputStudentName = 'me.free_trial_field_input_student_name',
  freeTrialFieldInputEmailAddress = 'me.free_trial_field_input_email_address',
  freeTrialFieldInputPhoneNumber = 'me.free_trial_field_input_phone_number',
  freeTrialFieldInputPersonBooking = 'me.free_trial_field_input_person_booking',

  // Dropdowns / Select Inputs
  freeTrialFieldInputPrimaryInstrument = 'me.free_trial_field_input_primary_instrument',
  freeTrialFieldInputAgeBracket = 'me.free_trial_field_input_age_bracket',
  freeTrialFieldInputLocation = 'me.free_trial_field_input_location',
  freeTrialFieldInputHowDidYouHearAboutUs = 'me.free_trial_field_input_how_did_you_hear_about_us',

  // Additional Input Fields
  freeTrialFieldInputMusicExperience = 'me.free_trial_field_input_music_experience',

  // Open Day (Sat 12 Sep 2026)
  openDayBannerViewed = 'me.open_day_banner_viewed',
  openDayBannerClicked = 'me.open_day_banner_clicked',
  openDayBannerDismissed = 'me.open_day_banner_dismissed',
  openDayPageViewed = 'me.open_day_page_viewed',
  openDayRsvpCtaClicked = 'me.open_day_rsvp_cta_clicked',
  openDayDirectionsClicked = 'me.open_day_directions_clicked',
  openDayAddToCalendar = 'me.open_day_add_to_calendar',
  openDayTrialCtaClicked = 'me.open_day_trial_cta_clicked',
  openDayEventbriteFallbackClicked = 'me.open_day_eventbrite_fallback_clicked',

  // FAQ: fires on open only, with a stable question_id
  faqOpened = 'me.faq_opened',

  // TidioChat Events
  tidioChatPreFormFilled = 'me.tidio_chat_pre_form_filled',
}
